import './index.scss'
import { initApp, setActiveNav } from 'app/js/app'


// WEBPACK FOOTER //
// ./src/404/index.js